import { render } from "./QQ.vue?vue&type=template&id=886458c0"
import script from "./QQ.vue?vue&type=script&lang=js"
export * from "./QQ.vue?vue&type=script&lang=js"

import "./QQ.vue?vue&type=style&index=0&id=886458c0&lang=css"

import exportComponent from "/workspace/251623126/emo-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__